import { Card, Col, Row } from 'antd';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { type TrimBlockSpecsFragment } from '../../../../api/fragments/TrimBlockSpecs';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import useSystemSwitchData from '../../../../utilities/useSystemSwitchData';
import ColorBlockSettingField from './ColorBlockSettingField';

type ColorBlockFormProps = {
    trimBlock: TrimBlockSpecsFragment;
    disabled?: boolean;
};

const ColorBlockForm = ({ trimBlock, disabled = false }: ColorBlockFormProps) => {
    const { t } = useTranslation(['variantConfiguratorDetails']);
    const { yesNoSwitch } = useSystemSwitchData();

    const [field] = useField<boolean>('colorBlockInput.isActive');

    return (
        <>
            <Card>
                <Row gutter={14}>
                    <Col lg={12} xs={24}>
                        <FormFields.TranslatedInputField
                            {...t('variantConfiguratorDetails:fields.colors.sectionTitle', { returnObjects: true })}
                            disabled={disabled}
                            name="colorBlockInput.sectionTitle"
                            required
                        />
                    </Col>
                    <Col lg={12} xs={24}>
                        <FormFields.SwitchField
                            {...yesNoSwitch}
                            {...t('variantConfiguratorDetails:fields.colors.isActive', { returnObjects: true })}
                            disabled={disabled}
                            name="colorBlockInput.isActive"
                        />
                    </Col>
                </Row>
            </Card>
            {field.value && (
                <ColorBlockSettingField
                    disabled={disabled}
                    name="colorBlockInput.colorSettings"
                    trimBlock={trimBlock}
                />
            )}
        </>
    );
};

export default ColorBlockForm;
